import moment from 'moment'
import _ from 'lodash'
import {
  CANALS,
  ERROR_UPDATE_PROMO,
  ERROR_WRONG_INFORMATIONS,
  FREEDELIVERY,
  PROMOTYPES,
  SUITABLE_ORDER_TYPES, SUCCESS_UPDATE_TEXT
} from '../../constants'
import { getFirebasePath, isObjectNotEmpty, isStringNotNull } from '../../utils/tools'
import { addPromo, updatePromo } from '../../apis/shop.service'
import { sendCloudWatchAlert } from '../../utils/applicationError'
import { checkIntegrationAccess } from 'src/utils/externalIntegration'
import { showNotification } from '../../components/Notification/Notification.view';
import store from 'src/utils/store'
export const onChangeData = ({ target }, stateObj, setStateObj) => {
  const { promo, errorTitle } = stateObj;
  let { id, value } = target;
  if (id === 'promoCode') {
    value = value.replace(/[^a-zA-Z0-9-_]/g, '');
  }
  if (id === 'minBasketPrice' || id === 'count' || id === 'value') {
    value = value < 0 ? 0 : value;
  }

  setStateObj({
    promo: { ...promo, [id]: value },
    errorTitle: id === 'promoCode' ? null : errorTitle
  });
};

export const handleChangeOrderTypes = (selectedOrderTypes, setStateObj, orderType) => {
  const index = selectedOrderTypes.indexOf(orderType);
  index === -1 ? selectedOrderTypes.push(orderType) : selectedOrderTypes.splice(index, 1);
  setStateObj({
    selectedOrderTypes
  });
};

export const handleChangeCanal = ({ target }, setStateObj) => {
  const { value } = target;
  setStateObj({
    selectedCanals: value
  });
};
export const handleAddPromo = async (openErrorModal, createPromo, isAllShops, closeModal, stateObj, setStateObj, shopId) => {
  const { promo, selectedOrderTypes, selectedCanals, selection, isExpiredDate } = stateObj;
  const promotions = getAllPromotions(isAllShops);
  let { value, count } = promo;

  const { promoCode, promotionType, ref = '', date, minBasketPrice = 0 } = promo;

  count = count === 0 ? '' : count;
  value =
    promotionType !== PROMOTYPES.freeDelivery
      ? value === 0
        ? ''
        : parseFloat(value)
      : FREEDELIVERY;
  const promoToCkeck = promoCode.replace(/\s+/g, '');
  if (
    !isStringNotNull(promotionType) ||
    !isStringNotNull(promoCode) ||
    !isStringNotNull(value) ||
    !isStringNotNull(count) ||
    (!isStringNotNull(ref) && checkIntegrationAccess('promoCode', 'obligatoryRef', shopId)) ||
    !isStringNotNull(promoToCkeck) || !isObjectNotEmpty(selectedOrderTypes) || !isObjectNotEmpty(selectedCanals)
  ) {
    openErrorModal(ERROR_WRONG_INFORMATIONS);
  }
  else if (promoCode.length < 5) setStateObj({ errorTitle: { promotionMinLength: true } });
  else {
    let newPromo = {};
    const type =
      promotionType === PROMOTYPES.percentage
        ? value > 100
          ? '100%'
          : `${parseInt(value, 10)}%`
        : value;
    newPromo = {
      count: parseInt(count, 10),
      type,
      ref,
      expired: false,
      promoCode,
      nbUsed: 0,
      isGeneralData: isAllShops,
      minBasketPrice: !isStringNotNull(minBasketPrice) ? 0 : parseFloat(minBasketPrice),
      date: createPromo ? moment().format() : date,
      canals: _.map(selectedCanals, canal => {
        return getObjKey(canal, CANALS);
      }),
      orderTypes: _.map(selectedOrderTypes, orderType => {
        return getObjKey(orderType, SUITABLE_ORDER_TYPES);
      }),
      startedDate: isExpiredDate ? moment(selection?.startDate).format() : null,
      endedDate: isExpiredDate ? moment(selection.endDate).format() : null
    };
    if (createPromo &&
      _.some(promotions, promotion =>
        promotion?.promoCode && getFirebasePath(promotion?.promoCode?.toLowerCase()) === getFirebasePath(promoCode?.toLowerCase())
      )) {
      setStateObj({ errorTitle: { promotionAlreadyExist: true } });
    } else {
      try {
        setStateObj({ isLoading: true });
        createPromo ? await addPromo(newPromo) : await updatePromo(newPromo);
        showNotification(
          'light',
          'ltr',
          'primary',
          SUCCESS_UPDATE_TEXT,
          `Ce code promotionnel a été ${createPromo ? 'ajouté' : 'modifié'} .`
        );
      } catch (error) {
        sendCloudWatchAlert(`Could not create promotion, ${error}`);
        openErrorModal(ERROR_UPDATE_PROMO);
      }
      setStateObj({ promo: {}, isLoading: false });
      handleClose(closeModal);
    }
  }
};

export const handleClose = closeModal => {
  closeModal();
};
export const getObjKey = (value, data) => {
  return _.keys(data).find(key => data[key] === value);
};

export const getCanals = savedCanals => {
  return _.map(savedCanals, i => {
    return CANALS[i];
  });
};
export const handleChange = (isExpiredDate, setStateObj, createPromo) => {
  if (createPromo) {
    setStateObj({ isExpiredDate: !isExpiredDate });
  }

};
export const onSelectDate = (ranges, stateObj, setStateObj) => {
  const selectedRange = ranges.selection;
  selectedRange.endDate = moment(ranges.selection.endDate).endOf('day').toDate();
  if (!stateObj.isSelectingRange) {
    setStateObj({
      isSelectingRange: true,
      open: true,
      selection: selectedRange
    });
  } else {
    setStateObj({
      selection: selectedRange,
      open: false,
      isSelectingRange: false
    });
  }
};

export const getAllPromotions = (isAllShops) => {
  const { shop = {}, shops: allShops } = store.getState().firebaseRealTime;
  const shops = isAllShops ? allShops : [shop];
  let generalPromotions = {};
  _.forEach(shops, shop => {
    _.forEach(shop?.promotions, (promotion, promoCode) => {
      generalPromotions[promoCode] = promotion
    })
  });
  return generalPromotions;
};

export const onClose = setStateObj => {
  setStateObj({
    open: false
  });
};
export const onClick = (event, setStateObj, stateObj) => {
  setStateObj({
    anchorEl: event.currentTarget,
    open: !stateObj.open
  });
};